import { Component, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AuthenticationService } from '../../../../authentication/authentication.service';
import { hasRole, Role } from '../../../enums/role';
import { NavigationItemComponent } from '../navigation-item/navigation-item.component';

@Component({
    selector: 'mce-navigation',
    imports: [NavigationItemComponent, MatListModule, MatIconModule],
    templateUrl: './navigation.component.html'
})
export class NavigationComponent {

  authenticationService = inject(AuthenticationService);

  protected readonly viewModel = computed(() => {
    let roles = this.authenticationService.currentUserState()?.roles || []
    let userHasRole = (role: Role) => hasRole(roles, role)
    return {
      showDashboardLink: true,
      showProjectsLink: true,
      showSiteAdminLink: userHasRole(Role.Administrator),
      showAppHelpLink: true,
      showMyCableEngineeringLink: true
    };
  });

  protected get vm() { return this.viewModel(); }

}
